import React from "react"
import Typography from "aldoo-ra/Typography"
import {
  DocumentTextIcon,
  FolderIcon,
  CubeIcon,
} from "@heroicons/react/24/outline"

const ReviewStep = ({ manifest }) => {
  if (!manifest) {
    return (
      <div className="flex items-center justify-center p-12">
        <Typography variant="admin_body_dim">
          No package data available
        </Typography>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      {/* Package Info Card */}
      <div className="bg-admin_canvas rounded-2xl p-6 border border-admin_bordered">
        <div className="space-y-4">
          <div className="flex items-start gap-3">
            <DocumentTextIcon className="w-5 h-5 text-admin_primary flex-shrink-0 mt-0.5" />

            <div className="flex-1">
              <Typography 
                variant="admin_body_accent" className="text-admin_text_secondary"
              >
                Package Name
              </Typography>

              <Typography variant="admin_body">
                {manifest.name || "Unnamed Package"}
              </Typography>
            </div>
          </div>

          <div className="h-px bg-admin_bordered" />

          <div className="flex items-start gap-3">
            <DocumentTextIcon className="w-5 h-5 text-admin_primary flex-shrink-0 mt-0.5" />

            <div className="flex-1">
              <Typography 
                variant="admin_body_accent" className="text-admin_text_secondary"
              >
                Source File
              </Typography>

              <Typography variant="admin_body">
                {manifest.filename || "Unknown"}
              </Typography>
            </div>
          </div>

          {manifest.description && (
            <>
              <div className="h-px bg-admin_bordered" />
              <div className="flex items-start gap-3">
                <DocumentTextIcon className="w-5 h-5 text-admin_primary flex-shrink-0 mt-0.5" />

                <div className="flex-1">
                  <Typography 
                    variant="admin_body_accent" className="text-admin_text_secondary"
                  >
                    Description
                  </Typography>

                  <Typography variant="admin_body">
                    {manifest.description}
                  </Typography>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Content Section */}
      {manifest.refs && Object.entries(manifest.refs).length > 0 && (
        <div className="bg-admin_canvas rounded-2xl p-6 border border-admin_bordered">
          <div className="flex items-center gap-2 mb-4">
            <CubeIcon className="w-5 h-5 text-admin_primary" />

            <Typography variant="admin_body_accent">
              Database Content
            </Typography>
          </div>

          <div className="space-y-3">
            {Object.entries(manifest.refs).map(([key, value]) => (
              <div
                key={key}
                className="flex items-center justify-between p-3 bg-admin_paper rounded-lg border border-admin_bordered"
              >
                <Typography variant="admin_body">
                  {key}
                </Typography>

                <div className="px-3 py-1 bg-admin_primary/10 rounded-full">
                  <Typography 
                    variant="admin_txt1" 
                    className="text-admin_primary font-medium"
                  >
                    {value} items
                  </Typography>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Files Section */}
      {manifest.files && Object.entries(manifest.files).length > 0 && (
        <div className="bg-admin_canvas rounded-2xl p-6 border border-admin_bordered">
          <div className="flex items-center gap-2 mb-4">
            <FolderIcon className="w-5 h-5 text-admin_primary" />

            <Typography variant="admin_body_accent">
              Files
            </Typography>
          </div>

          <div className="space-y-3">
            {Object.entries(manifest.files).map(([key, value]) => (
              <div
                key={key}
                className="flex items-center justify-between p-3 bg-admin_paper rounded-lg border border-admin_bordered"
              >
                <Typography variant="admin_body">
                  {key}
                </Typography>

                <div className="px-3 py-1 bg-admin_primary/10 rounded-full">
                  <Typography 
                    variant="admin_txt1" 
                    className="text-admin_primary font-medium"
                  >
                    {value} files
                  </Typography>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Empty State */}
      {(!manifest.refs || Object.entries(manifest.refs).length === 0) &&
        (!manifest.files || Object.entries(manifest.files).length === 0) && (
          <div className="text-center bg-admin_canvas rounded-2xl border border-admin_bordered p-12">
            <Typography variant="admin_body_dim">
              No content or files in this package
            </Typography>
          </div>
        )}
    </div>
  )
}

export default ReviewStep
